import InNumber from './innumber.vue';
import SearchBox from './searchbox.vue';

const inNumber = {
	install:function(Vue){
		Vue.component('InNumber',InNumber);
		Vue.component('SearchBox',SearchBox);
	}
}

export default inNumber;